import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageOcr from '../../components/ImageOcr';

const ImageOcrPage: React.FC = () => (
  <ToolLayout
    title="Image to Text (OCR) - Extract Text from Images | AllTools"
    description="Extract text from images using OCR. Convert photos of text to editable text. Free online OCR tool."
    canonicalPath="/image-to-text-ocr"
  >
    <ImageOcr />
  </ToolLayout>
);

export default ImageOcrPage;
